import Fab, { FabProps } from '@mui/material/Fab';
import { createLink } from '@tanstack/react-router';

const MUIFabLink = (props: FabProps<'a'>) => <Fab {...props} component="a" />;

export const RouterFabLink = createLink(MUIFabLink);
